/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsXmarkColumnRight: {
  name: 'xmark-column-right';
  data: string;
} = {
  name: 'xmark-column-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 1A.5.5 0 0 1 9 .5h6a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5v-3.5H7a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h1.5V1ZM9 5.5H7.5v5h7v-5H9Zm.5 6v3h5v-3h-5Zm0-7v-3h5v3h-5ZM4.854 6.146a.5.5 0 0 1 0 .707L3.707 8l1.147 1.146a.5.5 0 1 1-.708.707L3 8.707 1.854 9.853a.5.5 0 1 1-.708-.707L2.293 8 1.146 6.853a.5.5 0 1 1 .708-.707L3 7.293l1.146-1.147a.5.5 0 0 1 .708 0Z" fill="currentColor"/></svg>`,
};
